import React from 'react';
import "./menu.css";
import { Link } from 'react-router-dom';
import { HashLink, NavHashLink } from 'react-router-hash-link';
import IMAGES from "../../images/images";



export default function Menu({ menuOpen, setMenuOpen}) {

    console.log(menuOpen);
    return (
        <div className={"menu "+(menuOpen && "active")} onClick={() => setMenuOpen(true)}>
            <div className="menu__wrapAll">
                <div className="menuWrapper">
                    <HashLink smooth to="/#div1">
                        <li onClick={() => setMenuOpen(false)}>
                            Home
                        </li>
                    </HashLink>
                    <Link to="/about">
                        <li onClick={() => setMenuOpen(false)}>
                            About
                        </li>
                    </Link>
                    <NavHashLink
                        smooth
                        to="/#portfolio"
                        activeClassName="selected"
                        activeStyle={{ color: 'red' }}>
                        <li onClick={() => setMenuOpen(false)}>
                            Portfolio
                        </li>
                    </NavHashLink>
                    <Link to="/blog">
                        <li onClick={() => setMenuOpen(false)}>
                            Blog
                        </li>
                    </Link>
                    <Link to="/contact">
                        <li onClick={() => setMenuOpen(false)}>
                            Contact
                        </li>
                    </Link>
                </div>
                <div className="menu__social">
                    <h3>follow</h3>
                    <li>
                        <a href="https://github.com/ArcOmotola" target='_blank' rel='noopener noreferrer'>
                            <img src={IMAGES.githubIcon} alt="" />
                        </a>
                        <a href="https://twitter.com/omo_t_quantum" target='_blank' rel='noopener noreferrer'>
                            <img src={IMAGES.twitter} alt="" />
                        </a>
                        <a href="https://www.instagram.com/p/CKyBE2ZFdEC/?utm_medium=copy_link" target='_blank' rel='noopener noreferrer'>
                            <img src={IMAGES.instagram} alt="" />
                        </a>
                        <a href="https://www.linkedin.com/in/omotola-ogunsola-13a60710b" target='_blank' rel='noopener noreferrer'>
                            <img src={IMAGES.linkedIn} alt="" />
                        </a>
                    </li>
                </div>
            </div>
        </div>
    )
}
